<div class="ct-absolute-center">
    <a [routerLink]="['/login']">
        <p-messages [value]="msgs" [closable]="false"></p-messages>
    </a>
    <button pButton type="text" [routerLink]="['/login']" icon="fa-sign-in" label="Log in"></button>
</div>